export default __webpack_public_path__ + "static/media/shape2.cd52464f.svg";